/** Box 7 of the ICS 234-CG, the Planning Section Chief's Prepared by. */

import type React from 'react';

import { IcsPreparedByBox } from '../IcsPreparedByBox';
import { ICS234_BOX_LABELS } from './constants';

export const Ics234SignatureBox: React.FC<{ periodNumber: number }> = ({
  periodNumber,
}) => (
  <IcsPreparedByBox
    baseId="ICS_234"
    periodNumber={periodNumber}
    boxLabel={ICS234_BOX_LABELS.preparedBy}
    testId="ics234-signature-box"
  />
);

export default Ics234SignatureBox;
